export default __webpack_public_path__ + "static/media/MPUR_03_mos.58b23479.wav";